import { BarChart3 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DataNotFound } from "../common/DataNotFound";

/** What a chart shows when it has nothing to plot (no rows, or all zero).
 *  Same look as the listing empty state, without card chrome, since the
 *  chart already sits in a card. */
export function ChartEmptyState({ label }: { label?: string }) {
  const { t } = useTranslation("common");
  return (
    <DataNotFound
      bare
      compact
      icon={BarChart3}
      className="!min-h-[140px] w-full"
      title={
        label ?? t("emptyState.chart", { defaultValue: "No data to display" })
      }
      description={t("emptyState.description", {
        defaultValue: "There is nothing to show here yet.",
      })}
    />
  );
}
